// Volume/bundle selector (1/3/5-pack picker) for the volume_selector block. Tier availability is
// looked up from a per-variant map embedded by block-volume-selector.liquid (booleans only - the raw
// inventory count is never sent to the browser) and kept in sync with the native "variant:change"
// event the theme already dispatches elsewhere, so switching Size/Color updates it instantly with no
// extra request.
(function () {
  function init(widget) {
    const availability = JSON.parse(widget.querySelector('[data-volume-availability]').textContent);
    const options = Array.from(widget.querySelectorAll('.volume-selector__option'));
    const inputs = Array.from(widget.querySelectorAll('.volume-selector__input'));
    const variantIdInput = widget.querySelector('.volume-selector__variant-id');
    const qtyInput = widget.querySelector('.volume-selector__qty-input');
    const packPropertyInput = widget.querySelector('.volume-selector__pack-property');
    const submitButton = widget.querySelector('.volume-selector__submit');
    const productFormId = widget.dataset.productFormId;

    function selectedPackSize() {
      const checked = inputs.find((input) => input.checked);
      return checked ? checked.value : '1';
    }

    function applyPackSize(packSize) {
      if (qtyInput) qtyInput.value = packSize;

      if (packPropertyInput) {
        packPropertyInput.value = packSize;
        // Only ever submitted for bundles (3 or 5) - see block-volume-selector.liquid's doc comment.
        packPropertyInput.disabled = packSize === '1';
      }
    }

    function updateAvailability(variantId, variantAvailable) {
      const tiers = availability[variantId];
      if (!tiers) return;

      let selected = selectedPackSize();
      let selectedStillAvailable = variantAvailable && tiers[selected];

      // Deliberately not setting the native `disabled` attribute on the <input>: the theme's own
      // CSS hides a block-swatch entirely when its input is `:disabled` (used elsewhere for hiding
      // combinations that don't exist at all), which isn't what we want here - a sold-out tier
      // should stay visible, just marked unavailable and unselectable via pointer-events below.
      const unavailablePackSizes = new Set();

      options.forEach((option) => {
        const packSize = option.dataset.packSize;
        const available = variantAvailable && tiers[packSize];

        option.classList.toggle('is-disabled', !available);
        if (!available) unavailablePackSizes.add(packSize);
      });

      if (!selectedStillAvailable) {
        const fallbackInput = inputs.find((input) => !unavailablePackSizes.has(input.value));
        if (fallbackInput) {
          fallbackInput.checked = true;
          selected = fallbackInput.value;
        }
      }

      applyPackSize(selected);

      if (variantIdInput) variantIdInput.value = variantId;

      if (submitButton) {
        submitButton.disabled = !variantAvailable;
        const content = submitButton.querySelector('.button__content');
        if (content) {
          content.textContent = variantAvailable
            ? widget.dataset.addToCartLabel
            : widget.dataset.soldOutLabel;
        }
      }
    }

    inputs.forEach((input) => {
      input.addEventListener('change', () => applyPackSize(input.value));
    });

    document.addEventListener('variant:change', (event) => {
      // Not using event.detail.formId here: the theme's own VariantPicker sets it via
      // `_form.id`, but every product form has a hidden <input name="id"> (the variant id
      // field), and that named control shadows the form element's `id` DOM property - so
      // detail.formId is actually that <input> element, not a string, and can never match
      // productFormId. event.target is the form the event actually dispatched on;
      // getAttribute('id') reads the raw attribute and isn't affected by the same shadowing.
      if (event.target.getAttribute('id') !== productFormId) return;
      try {
        updateAvailability(String(event.detail.variant.id), event.detail.variant.available);
      } catch (error) {
        console.error('volume-selector: failed to update availability', error);
      }
    });

    applyPackSize(selectedPackSize());
  }

  document.querySelectorAll('.volume-selector').forEach((widget) => {
    try {
      init(widget);
    } catch (error) {
      console.error('volume-selector: failed to initialize', error);
    }
  });
})();
